import './styles.scss'
import React from 'react'
import FileViewer from 'react-file-viewer'

import { FILE_PREVIEW_SUPPORT } from '../../../constants'
import { getStaticImage } from 'utils/statics'
import { IMAGE_FORMATS } from 'constants/unsupportedFileFormats'
import MaliciousContentMessage from './MaliciousContentMessage'
import { lang } from 'utils/helpers'

const onDownloadClick = ({ url, mimeSubtype, e }) => {
  e.preventDefault()
  if (url) {
    fetch(url)
      .then(response => {
        response.blob().then(blob => {
          let _url = window.URL.createObjectURL(blob)
          let a = document.createElement('a')

          let filename = ''
          try {
            filename = (url || '').split('/').pop() || 'file.' + mimeSubtype
          } catch {
            filename = 'file.' + mimeSubtype
          }
          a.href = _url
          a.download = filename
          a.hidden = true
          document.body.appendChild(a)
          a.click()
          a.parentNode.removeChild(a)
        })
      })
  }
}

const fileWrapper = (url, thumb, mimeSubtype, fileType) => {
  return (
    <div className="conversation-attachment">
      <a href={url} target='_blank' rel='noopener noreferrer'>
        <img
          src={thumb}
          className="png-image"
          alt={url}
          style={{ objectFit: "contain" }}
          title={lang("dashboard_open_file")}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null
            currentTarget.src = getStaticImage('/icons/orange-brand/icon-document.svg')
          }}
        />
      </a>
      <div className='file-preview-options'>
        <img src={fileType} className='icon-default' alt={url} />
        <img
          alt="icon-download"
          className='icon-download'
          src={getStaticImage('/icons/orange-brand/icon-arrow-down-tray-dark.svg')}
          onClick={(e)=> onDownloadClick({ url, mimeSubtype, e })}
        />
      </div>
    </div>
  )
}

const getDriver = (props) => {
  const { mimeType, mimeSubtype, id, url, thumb, hiddenDownload = false, hiddenControls = false } = props
  const subtype = mimeSubtype === 'x-m4v' ? 'mp4' : mimeSubtype

  if (mimeType === 'audio') {
    return (
      <div className='audio-file'>
        <audio controls={!hiddenControls}>
          <source src={url} type='audio/ogg' />
          Your browser does not support the audio element.
        </audio>
      </div>
    )
  }

  if (mimeSubtype === 'pdf') {
    return (
      fileWrapper(url, thumb || getStaticImage('/pdf-default.png'), mimeSubtype, getStaticImage('/pdf-default.png'))
    )
  }

  if (mimeType === 'image' && !IMAGE_FORMATS.includes((subtype || ''))) {
    return (
      <div className="conversation-attachment">
        <a href={url} target='_blank' rel='noopener noreferrer'>
          <img
            src={url}
            className='png-image'
            alt={url}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null
              currentTarget.src = getStaticImage('/icons/orange-brand/icon-document.svg')
            }}
          />
        </a>
        {
          !hiddenDownload ? (
            <div className='file-preview-options--row-reverse'>
              <img
                alt="icon-download"
                className='icon-download'
                src={getStaticImage('/icons/orange-brand/icon-arrow-down-tray-dark.svg')}
                onClick={(e)=> onDownloadClick({ url, mimeSubtype, e })}
              />
            </div>
          ) : null
        }
      </div>
    )
  }

  if (IMAGE_FORMATS.includes((subtype || ''))) {
    return (
      <a href={url} target='_blank' rel='noopener noreferrer'>
        <img src={getStaticImage('/image-default.png')} alt="Default" />
        {
          !hiddenDownload ? (
            <div className='file-preview-options--row-reverse'>
              <img
                alt="icon-download"
                className='icon-download'
                src={getStaticImage('/icons/orange-brand/icon-arrow-down-tray-dark.svg')}
                onClick={(e)=> onDownloadClick({ url, mimeSubtype, e })}
              />
            </div>
          ) : null
        }
      </a>
    )
  }

  if (FILE_PREVIEW_SUPPORT.includes((subtype || '').toLowerCase())) {
    return <FileViewer id={id || ''} fileType={subtype} filePath={url} errorComponent={null} unsupportedComponent={null} />
  }

  return (
    fileWrapper(url, getStaticImage('/file-default.png'), mimeSubtype, getStaticImage('/file-default.png'))
  )

}

export default function Attachment(props) {
  const { flexDirection } = props
  return (
    <div className={`conversation-attachment-container flex-direction--${flexDirection || 'row-reverse'}`}>
      {props.withVirus ? <MaliciousContentMessage />
        : (
          <div className='conversation-attachment'>
            {getDriver(props)}
          </div>
        )
      }
    </div>
  )
}
